import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

import { getAgencyProfileRoutes } from '../agency-routes/agencyProfileRoutes';

const AgenciesPage = lazy(() => import('../../../../main/backoffice/agencies/BackofficeAgenciesPage'));

export const backOfficeAgenciesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense fallback={<DataLoader />}>
        <AgenciesPage />
      </Suspense>
    ),
  },
  {
    path: ':id',
    children: getAgencyProfileRoutes(['add-member', 'users/:invitationId']),
  },
  {
    path: '*',
    element: <Error404Page />,
  },
  {
    path: ':any/*',
    element: <Error404Page />,
  },
];
